// ============================================================
// IMPORTANT: Replace this placeholder with your REAL Mercado Pago
// payment link. Every CTA on the page points to this constant.
// ============================================================
export const MERCADO_PAGO_URL = '#mercadopago'

export const PRICE_TODAY = '$19.990 ARS'
export const PRICE_FULL = '$97.000 ARS'

export const SECURE_TEXT =
  'Pago 100% seguro procesado por Mercado Pago · Acceso inmediato · Garantía 7 días'

// Countdown deadline — 48 hours from a fixed reference so sections stay in sync.
// Using a rolling 48h window from page mount via the hook.
export const COUNTDOWN_HOURS = 48

export interface Testimonial {
  initials: string
  color: string
  name: string
  city: string
  role: string
  text: string
}

export const earlyTestimonials: Testimonial[] = [
  {
    initials: 'MR',
    color: '#00C853',
    name: 'Martina Rossi',
    city: 'Córdoba',
    role: 'Estudiante de Diseño',
    text: 'Llegaba a fin de mes en cero sin entender por qué. Con el sistema empecé a ahorrar el primer mes. Cambió mi cabeza.',
  },
  {
    initials: 'JC',
    color: '#2196F3',
    name: 'Joaquín Castro',
    city: 'Rosario',
    role: 'Empleado de comercio',
    text: 'Pensaba que invertir era para ricos. Hoy tengo mi fondo de emergencia armado y mi primera inversión hecha.',
  },
  {
    initials: 'SV',
    color: '#FFD700',
    name: 'Sofía Vega',
    city: 'Mendoza',
    role: 'Freelancer',
    text: 'El Ebook de IA me voló la cabeza. Sumé un ingreso extra usando herramientas gratis que ni sabía que existían.',
  },
]

export const moreTestimonials: Testimonial[] = [
  {
    initials: 'LF',
    color: '#FF9800',
    name: 'Lucas Fernández',
    city: 'La Plata',
    role: 'Estudiante',
    text: 'Por fin entiendo a dónde se me va la plata. Ordené todo en una semana.',
  },
  {
    initials: 'CG',
    color: '#4CAF50',
    name: 'Camila Giménez',
    city: 'Mar del Plata',
    role: 'Recepcionista',
    text: 'Pasé de no tener nada ahorrado a un colchón de 3 meses. Práctico y al hueso.',
  },
  {
    initials: 'TM',
    color: '#F44336',
    name: 'Tomás Medina',
    city: 'Salta',
    role: 'Programador junior',
    text: 'Lo apliqué tal cual viene. Cero vueltas, cero gurú. Resultados reales.',
  },
  {
    initials: 'AB',
    color: '#9C27B0',
    name: 'Abril Benítez',
    city: 'Neuquén',
    role: 'Estudiante de Medicina',
    text: 'Me sirvió para protegerme de la inflación sin saber nada de finanzas antes.',
  },
  {
    initials: 'NP',
    color: '#00BCD4',
    name: 'Nahuel Paredes',
    city: 'Tucumán',
    role: 'Repartidor',
    text: 'Con un sueldo común armé mi primer ahorro de verdad. Vale cada peso.',
  },
  {
    initials: 'VD',
    color: '#FFC107',
    name: 'Valentina Díaz',
    city: 'CABA',
    role: 'Community Manager',
    text: 'Lo recomiendo a todos mis amigos. Es lo que nadie te enseña en el colegio.',
  },
]

export interface Tomo {
  number: number
  name: string
  subtitle: string
  color: string
  star?: boolean
  points: string[]
  result: string
}

export const tomos: Tomo[] = [
  {
    number: 1,
    name: 'Control Total de tu Guita',
    subtitle: 'Saber a dónde va cada peso',
    color: '#4CAF50',
    points: [
      'Sistema de presupuesto simple y real',
      'Cómo trackear gastos sin volverte loco',
      'Detectar fugas de plata invisibles',
      'Plantillas listas para usar',
    ],
    result: 'Sabés exactamente en qué se te va la plata',
  },
  {
    number: 2,
    name: 'Protección Financiera',
    subtitle: 'Blindarte contra imprevistos',
    color: '#FFC107',
    points: [
      'Armar tu fondo de emergencia paso a paso',
      'Protegerte de la inflación argentina',
      'Evitar deudas que te hunden',
      'Salir de deudas con método',
    ],
    result: 'Dormís tranquilo aunque pase lo inesperado',
  },
  {
    number: 3,
    name: 'El Arte de Ahorrar',
    subtitle: 'Guardar plata sin sufrir',
    color: '#FF9800',
    points: [
      'Métodos de ahorro automático',
      'Dólares, plazo fijo y alternativas',
      'Metas de ahorro que sí se cumplen',
      'Trucos para ahorrar más cada mes',
    ],
    result: 'Tu ahorro crece todos los meses sin esfuerzo',
  },
  {
    number: 4,
    name: 'Iniciación a las Inversiones',
    subtitle: 'Hacer que la plata trabaje por vos',
    color: '#2196F3',
    points: [
      'Invertir desde cero sin miedo',
      'CEDEARs, FCI y opciones reales en Argentina',
      'Riesgo, plazos y diversificación explicados simple',
      'Tu primera inversión en menos de una semana',
    ],
    result: 'Hacés tu primera inversión con confianza',
  },
  {
    number: 5,
    name: 'Más Ingresos',
    subtitle: 'Ganar más sin depender de un solo sueldo',
    color: '#F44336',
    points: [
      'Ideas de ingresos extra para jóvenes',
      'Freelance y servicios digitales',
      'Monetizar lo que ya sabés hacer',
      'Cómo subir tu tarifa sin culpa',
    ],
    result: 'Tenés más de una fuente de ingresos',
  },
  {
    number: 6,
    name: 'Libertad Financiera',
    subtitle: 'Construir patrimonio a largo plazo',
    color: '#FFD700',
    star: true,
    points: [
      'Mentalidad de patrimonio, no de gasto',
      'Plan financiero a 5 y 10 años',
      'Interés compuesto a tu favor',
      'El mapa completo hacia la libertad',
    ],
    result: 'Tenés un plan claro hacia la libertad financiera',
  },
]

export interface Bono {
  number: string
  color: string
  name: string
  description: string
  oldPrice: string
}

export const bonos: Bono[] = [
  {
    number: '01',
    color: '#00C853',
    name: 'Plantillas de Finanzas',
    description:
      'Set completo de plantillas editables para presupuesto, ahorro e inversión.',
    oldPrice: '$12.000 ARS',
  },
  {
    number: '02',
    color: '#FFD700',
    name: 'Guía de Dólares & Inflación',
    description:
      'Cómo proteger tu plata en Argentina sin perder contra la inflación.',
    oldPrice: '$12.000 ARS',
  },
  {
    number: '03',
    color: '#2196F3',
    name: 'Checklist de Ingresos Extra',
    description:
      '30 ideas concretas de ingresos extra para arrancar esta semana.',
    oldPrice: '$10.000 ARS',
  },
]

export interface IATool {
  tool: string
  use: string
}

export const iaTools: IATool[] = [
  { tool: 'ChatGPT', use: 'Crear contenido, ideas y planificar ingresos' },
  { tool: 'Gemini', use: 'Investigar y resumir información financiera' },
  { tool: 'Canva IA', use: 'Diseñar tus servicios y vender online' },
  { tool: 'Notion IA', use: 'Organizar tus finanzas y proyectos' },
  { tool: 'CapCut IA', use: 'Editar videos para monetizar contenido' },
  { tool: 'Perplexity', use: 'Tomar decisiones de inversión informadas' },
  { tool: 'ElevenLabs', use: 'Crear voces y audios para tus proyectos' },
]

export interface FAQItem {
  q: string
  a: string
}

export const faqs: FAQItem[] = [
  {
    q: '¿Cómo recibo el Megapack?',
    a: 'Apenas confirmás el pago por Mercado Pago, recibís el acceso inmediato a todo el material digital. Sin esperas.',
  },
  {
    q: '¿Sirve si nunca manejé mis finanzas?',
    a: 'Totalmente. Está pensado desde cero, con lenguaje simple y paso a paso. No necesitás conocimientos previos.',
  },
  {
    q: '¿Es específico para Argentina?',
    a: 'Sí. Todo está adaptado a la realidad argentina: inflación, dólares, plazo fijo, CEDEARs y herramientas locales.',
  },
  {
    q: '¿Necesito saber de tecnología para el Ebook IA?',
    a: 'Para nada. Te llevamos de la mano con herramientas gratuitas y explicaciones simples para cualquier nivel.',
  },
  {
    q: '¿Los bonos y el Ebook IA están incluidos?',
    a: 'Sí, siempre. Los 3 bonos y el Ebook Premium de IA vienen incluidos sin costo extra en el Megapack.',
  },
  {
    q: '¿Los archivos son editables?',
    a: 'Las plantillas son 100% editables para que las adaptes a tu situación personal.',
  },
  {
    q: '¿Tiene garantía real?',
    a: 'Sí. Tenés 7 días de garantía total. Si no es lo que esperabas, te devolvemos el 100% sin preguntas.',
  },
]

export interface ComparisonRow {
  without: string
  with: string
}

export const comparison: ComparisonRow[] = [
  {
    without: 'Llegás a cero todos los meses',
    with: 'Sabés a dónde va cada peso',
  },
  {
    without: 'La inflación se come tus ahorros',
    with: 'Protegés tu plata de la inflación',
  },
  {
    without: 'Creés que invertir es para ricos',
    with: 'Hacés tu primera inversión',
  },
  { without: 'Dependés de un solo sueldo', with: 'Tenés ingresos extra' },
  {
    without: 'Vivís con estrés financiero',
    with: 'Tenés un colchón de emergencia',
  },
  { without: 'Sin plan a futuro', with: 'Tenés un plan claro a 5 años' },
]

export const painPoints: string[] = [
  'Cobrás y a los pocos días ya no te queda nada.',
  'No sabés bien en qué se te va la plata cada mes.',
  'La inflación se come todo lo que intentás ahorrar.',
  'Querés invertir pero pensás que es solo para ricos.',
  'Dependés 100% de un solo sueldo que nunca alcanza.',
  'Te da vergüenza no entender de finanzas a tu edad.',
  'Probaste mil "tips" de gurús que no sirvieron para nada.',
  'Sentís que vivís corriendo de atrás sin avanzar nunca.',
]

export const valueRows = [
  { item: '6 Tomos Completos de Finanzas', value: '$48.000 ARS' },
  { item: 'Bono 1 — Plantillas de Finanzas', value: '$12.000 ARS' },
  { item: 'Bono 2 — Guía de Dólares & Inflación', value: '$12.000 ARS' },
  { item: 'Bono 3 — Checklist de Ingresos Extra', value: '$10.000 ARS' },
  { item: 'Ebook Premium IA — El Multiplicador', value: '$15.000 ARS' },
]

export const steps = [
  { label: 'Controlar', color: '#4CAF50' },
  { label: 'Proteger', color: '#FFC107' },
  { label: 'Ahorrar', color: '#FF9800' },
  { label: 'Invertir', color: '#2196F3' },
  { label: 'Ganar más', color: '#F44336' },
  { label: 'Construir patrimonio', color: '#FFD700' },
]
